import { includes } from 'lodash';
import { transactionCreated } from '@blockcatio/tabby-library/lib/actions/transactions';
import { TransactionStatusEnum } from '@blockcatio/tabby-library/lib/constants';

import {
  paymentSendRejected,
  paymentAcceptRejected,
  paymentAcceptConfirmed,
  paymentCancelRejected,
  paymentCancelConfirmed,
} from '../actions/payments';
import { authorizeCatRejected, authorizeCatConfirmed } from '../actions/account';
import { authorizeTokenRejected, authorizeTokenConfirmed } from '../actions/token';
import {
  PAYMENT_SEND_SUBMITTED,
  PAYMENT_ACCEPT_SUBMITTED,
  PAYMENT_CANCEL_SUBMITTED,
  CAT_AUTHORIZATION_SUBMITTED,
  TOKEN_AUTHORIZATION_SUBMITTED,
  TRANSACTION_RECEIPTS_FETCHED,
} from '../actionTypes';

export default () => ({ getState, dispatch }) => next => (action) => {
  next(action);
  if (
    includes(
      [
        PAYMENT_SEND_SUBMITTED,
        PAYMENT_ACCEPT_SUBMITTED,
        PAYMENT_CANCEL_SUBMITTED,
        CAT_AUTHORIZATION_SUBMITTED,
        TOKEN_AUTHORIZATION_SUBMITTED,
      ],
      action.type,
    )
  ) {
    const id = action.paymentTransactionHash || action.transactionHash;
    const labels = {
      PAYMENT_SEND_SUBMITTED: 'Send Payment',
      PAYMENT_ACCEPT_SUBMITTED: 'Accept Payment',
      PAYMENT_CANCEL_SUBMITTED: 'Cancel Payment',
    };
    dispatch(transactionCreated(action.transactionHash, id, action.type, labels[action.type] || ''));
  }

  // Dispatch actions based on confirmed transactions' status.
  if (action.type === TRANSACTION_RECEIPTS_FETCHED) {
    action.transactionReceipts.forEach((receipt) => {
      const { status, transactionHash } = receipt;
      const transaction = getState().transactions.localTransactions[transactionHash];

      // Respond to transactions that failed.
      if (transaction && Number(status) === TransactionStatusEnum.failed) {
        // Get the create payment txHash from transaction.id.
        const paymentTransctionHash = transaction.id;
        switch (transaction.actionType) {
          case PAYMENT_SEND_SUBMITTED:
            dispatch(paymentSendRejected(paymentTransctionHash));
            break;

          case PAYMENT_ACCEPT_SUBMITTED:
            dispatch(paymentAcceptRejected(paymentTransctionHash));
            break;

          case PAYMENT_CANCEL_SUBMITTED:
            dispatch(paymentCancelRejected(paymentTransctionHash));
            break;

          case CAT_AUTHORIZATION_SUBMITTED:
            dispatch(authorizeCatRejected(transaction.transactionHash));
            break;

          case TOKEN_AUTHORIZATION_SUBMITTED:
            dispatch(authorizeTokenRejected(transaction.transactionHash));
            break;

          default:
          // Nothing to do.
        }
      }

      // Respond to transactions that succeeded.
      if (transaction && Number(status) === TransactionStatusEnum.succeeded) {
        // Get the create payment txHash from transaction.id.
        const paymentTransctionHash = transaction.id;
        switch (transaction.actionType) {
          case PAYMENT_ACCEPT_SUBMITTED:
            dispatch(paymentAcceptConfirmed(paymentTransctionHash));
            break;

          case PAYMENT_CANCEL_SUBMITTED:
            dispatch(paymentCancelConfirmed(paymentTransctionHash));
            break;

          case CAT_AUTHORIZATION_SUBMITTED:
            dispatch(authorizeCatConfirmed(transaction.transactionHash));
            break;

          case TOKEN_AUTHORIZATION_SUBMITTED:
            dispatch(authorizeTokenConfirmed(transaction.transactionHash));
            break;

          default:
          // Nothing to do.
        }
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/middleware/routeTransactions.js